import React from 'react';
import PropTypes from 'prop-types';

export default function SeatAvailableLegendIcon({ scaleFactor = 1 }) {
  return (
   <svg
    width={12 * scaleFactor}
    height={13 * scaleFactor}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
   >
     <rect y="0.5" width="12" height="12" rx="1" fill="#EAEEF0" />
     <rect x="2" y="2.5" width="7.99999" height="8" rx="1" fill="#194245" />
   </svg>
  );
}

SeatAvailableLegendIcon.propTypes = {
 scaleFactor: PropTypes.number,
};
